/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
import React from 'react';

const Monitor = () => {
  return <svg className="store-svg-monitor" viewBox="0 0 1025 1024">
    <path d="M510.635 36.864c263.509 0 477.867 214.357 477.867 477.867s-214.357 477.867-477.867 477.867-477.867-214.357-477.867-477.867 214.357-477.867 477.867-477.867M510.635 9.557c-278.528 0-505.173 226.645-505.173 505.173s226.645 505.173 505.173 505.173 505.173-226.645 505.173-505.173-226.645-505.173-505.173-505.173v0z"/>
    <path d="M795.989 329.045c-2.731 0-8.192 1.365-10.923 2.731l-163.84 76.459v-55.979c0-15.019-9.557-30.037-24.576-30.037h-382.293c-15.019 0-30.037 15.019-30.037 30.037v327.68c0 15.019 15.019 24.576 30.037 24.576h382.293c15.019 0 24.576-9.557 24.576-24.576v-38.229l165.205 75.093c4.096 1.365 6.827 2.731 10.923 2.731 9.557 0 16.384-6.827 16.384-19.115v-353.621c-1.365-10.923-8.192-17.749-17.749-17.749zM593.92 675.84h-382.293v-327.68h382.293v327.68zM785.067 684.032l-163.84-75.093v-170.667l163.84-75.093v320.853z"/>
  </svg>
};

export default Monitor;



// WEBPACK FOOTER //
// ./src/svgs/monitor.js